import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';
Chart.register(...registerables);

@Component({
  selector: 'app-load-watch-dashboard-all',
  templateUrl: './load-watch-dashboard-all.component.html',
  styleUrls: ['./load-watch-dashboard-all.component.css']
})

export class LoadWatchDashboardAllComponent implements OnInit, AfterViewInit {
  searchText: string = '';
  statusFilter: string = 'all';

  generators: any = {};
  stats = { total: 0, online: 0, offline: 0, starting: 0, error: 0 };
  markerCluster: any;

  private map!: L.Map;
  private powerChart: any;
  private loadChart: any;

  searchForm: FormGroup = this._formBuilder.group({
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
  });

  @ViewChild('powerChart') powerChartRef!: ElementRef;
  @ViewChild('loadChart') loadChartRef!: ElementRef;

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {
    this.fetchData(true)

  }

  ngAfterViewInit(): void {
    this.initMap();
    this.initCharts();
  }

  fetchData = async (showLoading: boolean = true) => {
    let model = this.searchForm.value;

    if (showLoading) {
      this._other.Showspinner()
    }

    let res = JSON.parse((await axios.post(`LoadWatchs_Dashboard`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.generators = res;

    const generators = res.Table || [];
    this.stats = {
      total: generators.length,
      offline: generators.filter((g: any) => g.tiGeneratorStatus === 0).length,
      online: generators.filter((g: any) => g.tiGeneratorStatus === 1).length,
      starting: generators.filter((g: any) => g.tiGeneratorStatus === 2).length,
      error: generators.filter((g: any) => g.tiGeneratorStatus === 3).length
    };

    this.updateMap();
    this.updateCharts()

  }

  private initMap(): void {
    if (this.map) {
      this.map.remove();
    }

    this.map = L.map('fleet-map').setView([35.6892, 51.3890], 9);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      subdomains: 'abcd',
      maxZoom: 19,
      minZoom: 6
    }).addTo(this.map);

    this.markerCluster = (L as any).markerClusterGroup({
      maxClusterRadius: 60,
      iconCreateFunction: function (cluster: any) {
        const count = cluster.getChildCount();
        const size = count > 100 ? 'large' : count > 50 ? 'medium' : 'small';
        const diameter = size === 'large' ? 48 : size === 'medium' ? 40 : 32;
        const fontSize = size === 'large' ? 16 : 12;
        return L.divIcon({
          html: `<div style="background:#4fc3f7; color:#0b0f17; border-radius:50%; width:${diameter}px; height:${diameter}px; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:${fontSize}px; border:2px solid #00e676; box-shadow: 0 0 20px rgba(79,195,247,0.4);">${count}</div>`,
          className: '',
          iconSize: [diameter, diameter],
          iconAnchor: [diameter / 2, diameter / 2]
        });
      }
    });

    this.map.addLayer(this.markerCluster);
  }

  updateMap(): void {
    if (!this.markerCluster || !this.generators || !this.generators.Table1) return;

    this.markerCluster.clearLayers();

    const mapData = this.generators.Table1;

    mapData.forEach((g: any) => {
      if (!g.fLat || !g.fLon) return;

      let color = '#546e7a';
      let statusText = 'نامشخص';

      switch (g.tiGeneratorStatus) {
        case 0: color = '#ef5350'; statusText = 'خاموش'; break;  // offline
        case 1: color = '#4caf50'; statusText = 'روشن'; break;   // online
        case 2: color = '#ffb74d'; statusText = 'در حال استارت'; break; // starting
        case 3: color = '#ff7043'; statusText = 'خطا'; break;    // error
      }

      const icon = L.divIcon({
        html: `<div style="background:${color}; width:14px; height:14px; border-radius:50%; border:2px solid #fff; box-shadow: 0 0 10px ${color}88;"></div>`,
        className: '',
        iconSize: [14, 14],
        iconAnchor: [7, 7]
      });

      const marker = L.marker([g.fLat, g.fLon], {
        icon: icon,
        title: g.strName
      });

      marker.bindPopup(`
        <div style="font-family:'vazir',sans-serif; direction:rtl; text-align:right; padding:4px 0; min-width:180px;">
            <div style="font-size:16px; font-weight:700; color:#4fc3f7; margin-bottom:8px;">
                ${g.strName}
            </div>
            <div style="font-size:12px; color:#b0bec5;">
              وضعیت: <span style="color:${color};">●</span> ${statusText}
            </div>
            <div style="font-size:12px; color:#b0bec5; margin-top:4px;">
              توان (kVA): ${g.ratedPower.toLocaleString()}
            </div>
            <div style="font-size:12px; color:#b0bec5; margin-top:4px;">
             مدت کارکرد (ساعت): ${g.totalRunHours.toLocaleString()}
            </div>
            <button class="btn btn-primary w-100 mt-3">
               مشاهده جزئیات
            </button>
        </div>
      `);

      this.markerCluster.addLayer(marker);
    });

    if (mapData.length > 0) {
      const bounds = this.markerCluster.getBounds();
      if (bounds.isValid()) {
        this.map.fitBounds(bounds, { padding: [50, 50], maxZoom: 13 });
      }
    }
  }

  private initCharts(): void {
    this.powerChart = new Chart(this.powerChartRef.nativeElement, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'توان ظاهری (kVA)',
          data: [],
          backgroundColor: 'rgba(79, 195, 247, 0.7)',
          borderColor: '#4fc3f7',
          borderWidth: 1,
          borderRadius: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { labels: { color: '#b0bec5', font: { family: 'vazir' } } },
          zoom: {
            pan: { enabled: true, mode: 'x' },
            zoom: { wheel: { enabled: true }, pinch: { enabled: true }, mode: 'x' }
          }
        },
        scales: {
          y: { beginAtZero: true, ticks: { color: '#78909c' }, grid: { color: '#1e293b' } },
          x: { ticks: { color: '#78909c', font: { family: 'vazir', size: 10 } }, grid: { display: false } }
        }
      }
    });

    this.loadChart = new Chart(this.loadChartRef.nativeElement, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'درصد بار (%)',
          data: [],
          backgroundColor: 'rgba(255, 183, 77, 0.7)',
          borderColor: '#ffb74d',
          borderWidth: 1,
          borderRadius: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { labels: { color: '#b0bec5', font: { family: 'vazir' } } },
          zoom: {
            pan: { enabled: true, mode: 'x' },
            zoom: { wheel: { enabled: true }, pinch: { enabled: true }, mode: 'x' }
          }
        },
        scales: {
          y: { beginAtZero: true, max: 100, ticks: { color: '#78909c' }, grid: { color: '#1e293b' } },
          x: { ticks: { color: '#78909c', font: { family: 'vazir', size: 10 } }, grid: { display: false } }
        }
      }
    });
  }

  private updateCharts(): void {
    if (!this.powerChart || !this.loadChart || !this.generators) return;

    if (this.generators.Table3) {
      this.powerChart.data.labels = this.generators.Table3.map((g: any) => g.strName);
      this.powerChart.data.datasets[0].data = this.generators.Table3.map((g: any) => g.powerApparent);
      this.powerChart.update();
    }

    if (this.generators.Table4) {
      this.loadChart.data.labels = this.generators.Table4.map((g: any) => g.strName);
      this.loadChart.data.datasets[0].data = this.generators.Table4.map((g: any) => g.tiLoadPercentage);
      this.loadChart.update();
    }
  }

  get tableData(): any[] {
    if (!this.generators || typeof this.generators !== 'object') return [];

    const combinedData = Object.keys(this.generators)
      .filter(key => key.startsWith('Table') && Array.isArray(this.generators[key]))
      .reduce((acc, key) => acc.concat(this.generators[key]), []);

    return combinedData.sort((a: any, b: any) => {
      const getWeight = (status?: string) => {
        if (status === 'online') return 2;
        if (status === 'offline') return 1;
        return 0;
      };

      const weightA = getWeight(a.instantStatus);
      const weightB = getWeight(b.instantStatus);

      return weightB - weightA;
    });
  }

  get filteredGenerators(): any[] {
    return this.tableData.filter(g => {
      const matchName = g.strName.toLowerCase().includes(this.searchText.toLowerCase());
      const matchStatus = this.statusFilter === 'all' || g.instantStatus === this.statusFilter;
      return matchName && matchStatus;
    });
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'online': return 'badge-success';
      case 'offline': return 'badge-danger';
      default: return 'badge-secondary';
    }
  }

  getStatusText(status: string): string {
    switch (status) {
      case 'online': return 'آنلاین';
      case 'offline': return 'آفلاین';
      default: return 'نامشخص';
    }
  }


}
